import React from 'react';

export const ThatsAllFolks = () => (
  <p style={{textAlign: 'center'}} data-testid='the-end'>
    Yay! You have seen it all.
  </p>
);